import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { format } from "date-fns";

@Component({
    selector: "app-drtv-footer",
    templateUrl: "./drtv-footer.component.html",
    styleUrls: ["./drtv-footer.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DrtvFooterComponent implements OnInit {
  currentYear = format(new Date(), "yyyy");

  constructor() {}

  ngOnInit(): void {}
}
